export const getApiBaseUrl = () => {
  const envBaseRaw = String(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BASE_URL || "").trim();
  const isLocalClient = ["localhost", "127.0.0.1"].includes(window.location.hostname);

  // Same-origin by default: the LAN edge server (3000/3443), CRA dev proxy and
  // the production Nginx all proxy /api and /socket.io themselves. Only honor
  // an explicit env override for local clients; never guess a backend port,
  // since TLS/HTTP mismatches there surface as opaque "Failed to fetch".
  const preferredBase = isLocalClient && envBaseRaw ? envBaseRaw : window.location.origin;

  // Normalize: remove trailing slashes so `${base}/api/...` never becomes `//api/...`
  return preferredBase.replace(/\/+$/, "");
};
